import React from "react";
import { makeStyles, useTheme } from "@material-ui/core";
import GaugeChart from "react-gauge-chart";
import { isEmpty, isNil } from "lodash";

const useStyles = makeStyles((theme) => ({
  container: {
    display: "flex",
    height: "100%",
    maxWidth: "100%",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
  },
}));

// const valor = {
//   val: 8,
//   perc: 0.88,
//   arcs: [
//     {
//       length: 0.8,
//       color: "#FF2E63",
//     },
//     {
//       length: 0.2,
//       color: "#30E3CA",
//     },
//   ],
// };

export default function DialKpi({ id, data }) {
  const {
    valor,
    label_valor,
  } = data;
  const theme = useTheme();
  const classes = useStyles();

  if (
    isNil(valor) ||
    isNil(valor?.arcs) ||
    isEmpty(valor?.arcs) ||
    isNil(valor?.val) ||
    isNil(valor?.perc)
  ) {
    return null;
  }

  return (
    <div className={classes.container}>
      <GaugeChart
        id={id}
        nrOfLevels={valor.arcs.length}
        arcsLength={valor.arcs.map((x) => x.length)}
        colors={valor.arcs.map((x) => x.color)}
        percent={valor.perc}
        arcPadding={0.05}
        needleColor={theme.palette.text.primary || "grey"}
        needleBaseColor={theme.palette.text.primary || "grey"}
        hideText={true}
      />
      {`${label_valor}: ${valor.val}`}
    </div>
  );
}
